import { OrgShopIdDto } from "@intelligems/ig-types";
import { invalidateOrganizationSummary } from "@src/api/organization-summaries/invalidate-organization-summary";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const cancelOrganizationSubscriptions = async (orgId: string) => {
  const resp = await api.post<string>(
    `/v2/admin/cancel-organization-subscriptions`,
    { orgId }
  );

  return resp.data;
};

export const useCancelOrganizationSubscriptions = (org: OrgShopIdDto) => {
  const queryClient = useQueryClient();
  return useMutation<string, Error, any, any>({
    mutationFn: async () => cancelOrganizationSubscriptions(org.id),
    onSuccess: async () => {
      await invalidateOrganizationSummary(queryClient, [org]);
    },
  });
};
